import { Link } from "react-router-dom";

/**
 * Elegant wordmark logo for Lumière Beauty Studio.
 * Pure typography — no icons. "è" intentionally accented.
 */
export default function Logo({ light = false, compact = false, withCenterDot = true }) {
  const color = light ? "#FFFFFF" : "#1A1A1A";
  const gold = "#B8964E";

  return (
    <Link
      to="/"
      data-testid="logo-link"
      className="inline-flex flex-col items-center leading-none"
      aria-label="Lumière Beauty Studio — pagina principală"
    >
      <span
        className="font-serif-display"
        style={{
          fontSize: compact ? "1.35rem" : "1.7rem",
          color,
          letterSpacing: "0.04em",
          fontWeight: 400,
        }}
      >
        Lumi
        <span style={{ color: gold, fontStyle: "italic" }}>è</span>
        re
      </span>
      {withCenterDot && (
        <span
          className="tracking-wider-luxe"
          style={{
            color: light ? "rgba(255,255,255,0.7)" : "#999",
            fontSize: compact ? "0.55rem" : "0.6rem",
            marginTop: compact ? 2 : 4,
            fontWeight: 400,
          }}
        >
          BEAUTY · STUDIO
        </span>
      )}
    </Link>
  );
}
